import { UserConversationsForPost } from "./UserConversation.types";
import React from "react";
import { UserConversation } from "./UserConversation";
import { Box, Checkbox } from "@mui/material";
import { ListItemIconButton } from "./UserConversationList.styles";

export function UserConversationList({
    onConversationSelect,
    selectedConversations,
    userConversationsList,
}: {
    onConversationSelect: (key: string) => void;
    selectedConversations: string[];
    userConversationsList: UserConversationsForPost[];
}) {
    return (
        <Box>
            {userConversationsList
                .filter((item) => item.name)
                .map((conversation: UserConversationsForPost, index) => (
                    <React.Fragment key={index}>
                        <UserConversation
                            conversation={conversation}
                            onItemClick={() => {
                                onConversationSelect(conversation.key);
                            }}
                            secondaryAction={
                                <ListItemIconButton disableRipple>
                                    <Checkbox
                                        checked={selectedConversations.includes(
                                            conversation.key,
                                        )}
                                        disableRipple
                                    />
                                </ListItemIconButton>
                            }
                        />
                    </React.Fragment>
                ))}
        </Box>
    );
}
